var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('MyNav'),_c('div',[_c('transition',{attrs:{"appear":"","enter-active-class":"animated fadeInDown customDelay","leave-active-class":"animated fadeOut"}},[_c('router-view')],1)],1),_c('MyFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }